// const ServerUrl = "https://ims.nepallife.com.np/backend/api";
// export const ServerUrlImage =
//   "https://ims.nepallife.com.np/backend/api/storage/fd/images";
// export default ServerUrl;

// const ServerUrl = "https://ims.nepallife.com.np/uat/backend/api";
// export const ServerUrlImage =
//   "https://ims.nepallife.com.np/uat/backend/api/storage/fd/images";
// export default ServerUrl;

// const isProduction = process.env.NODE_ENV === "production";

// const ServerUrl = isProduction
//   ? "https://ims.nepallife.com.np/backend/api"
//   : "https://ims.nepallife.com.np/uat/backend/api";

// export const ServerUrlImage = isProduction
//   ? "https://ims.nepallife.com.np/backend/api/storage/fd/images"
//   : "https://ims.nepallife.com.np/uat/backend/api/storage/fd/images";

// export default ServerUrl;

// const isProduction = process.env.NODE_ENV === "production";

// const ServerUrl = isProduction
//   ? "https://ims.nepallife.com.np/backend/api"
//   : "https://ims.nepallife.com.np/backend/api";

// export const ServerUrlImage = isProduction
//   ? "https://ims.nepallife.com.np/backend/api/storage/fd/images"
//   : "https://ims.nepallife.com.np/backend/api/storage/fd/images";

// export default ServerUrl;
const isProduction = process.env.NODE_ENV === "production";

const ServerUrl = isProduction
  ? "http://imsapi.prologicnepal.com/api"
  : "http://imsapi.prologicnepal.com/api";

export const ServerUrlImage = isProduction
  ? "http://imsapi.prologicnepal.com/api/storage/fd/images"
  : "http://imsapi.prologicnepal.com/api/storage/fd/images";

export default ServerUrl;
